<template>
    <div>
        <p>Downloading Excel File</p>
        <div :ref="'divloadingexport' + keyId" class="modal-body">
            <div class="position-relative">
                <div class="h100">
                    <div class="container h-100">
                        <div class="row h-100 justify-content-center align-items-center">
                            <div class="col-12">
                                <div class="h-100 text-center">
                                    <div class="alert alert-danger" role="alert" v-show="excelError">
                                        <span class="mdi mdi-alert-rhombus-outline"></span> {{$t('common.modalExcel.error')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-btn class="" medium elevation="3" @click="close" v-show="excelError">
            {{$t('common.lblClose')}}
        </v-btn>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        data: function () {
            return {
                excelError: false,
                excelTooLarge: false,
                isLoading: false
            }
        },
        props: {
            dynamicId: {
                type: String,
                required: true
            },
            instance: {
                type: String,
                required: true
            },
            keyId: {
                type: String,
                required: true
            },
            exportData: {
                required: true
            },
            url: {
                required: true
            }
        },
        async mounted() {
            await this.fnExcelExportation()
        },
        methods: {
            async fnExcelExportation() {
                let loader = this.$loading.show({ container: this.$refs["divloadingexport" + this.keyId], isFullPage: false });
                let data = this.exportData 
                await axios({
                    url: this.url, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                    params: data
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', data.fileName + '.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    loader.hide({ container: this.$refs["divloadingexport" + this.keyId] })
                    this.close();
                }).catch((exception) => {
                    loader.hide({ container: this.$refs["divloadingexport" + this.keyId] })
                    this.excelError = true;
                });
               
                

            },
            close() {
                this.$store.dispatch("removeWidgetCard", this.keyId);
            }
        }
    }
</script>

<style>
</style>